import { Component, inject, input } from '@angular/core';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { ModalService } from 'app/shared/services/modal/modal.service';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'info-modal',
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule],
  templateUrl: './info-modal.component.html',
  styleUrl: './info-modal.component.css'
})
export class InfoModalComponent {
  private readonly modalService = inject(ModalService);
  private readonly toast = inject(AlertService);
  private readonly translate = inject(TranslateService);

  modalId = input('confirm-modal');

  /** Personalización. `confirmLabel` es una KEY i18n (se traduce en el template con
   * el pipe); así no depende de que las traducciones ya estén cargadas al construir
   * el componente (el info-modal vive en la raíz y se crea antes del bundle i18n). */
  iconSrc = input('alert-icon.svg');
  confirmLabel = input('common.actions.accept');

  /** Two-way para PrimeNG [(visible)] usando el servicio */
  get isVisible(): boolean {
    return this.modalService.isVisible(this.modalId())();
  }

  set isVisible(v: boolean) {
    if (!v) this.modalService.closeModal(this.modalId());
  }

  /** Acceso a los datos del modal almacenados en el servicio */
  modalData = () => this.modalService.getData(this.modalId())();

  closeModal(): void {
    this.modalService.closeModal(this.modalId());
  }

  confirmAction(): void {
    const data = this.modalData();
    if (data?.onConfirm) {
      data.onConfirm();
    } else {
      this.toast.showAlertSuccess(
        this.translate.instant('common.success.ready'),
        this.translate.instant('common.success.actionConfirmed')
      );
    }
    this.modalService.closeModal(this.modalId());
  }
}
